
// import { useState } from "react";

// // ── Article imports ──────────────────────────────────────────
// import Article1 from "./Article1";
// import Article2 from "./Article2";
// import Article3 from "./Article3";
// import Article4 from "./Article4";
// import Article5 from "./Article5";
// import Article6 from "./Article6";
// import Article7 from "./Article7";
// // import article6 from "./article6";   ← add new articles here

// const allArticles = [Article1, Article2, Article3, Article4, Article5,Article6,Article7];
// // const allArticles = [article1, article2, article3, article4, article5, article6];

// // ─────────────────────────────────────────────────────────────
// //  Shared font scale (Playfair Display only, sizes in rem)
// // ─────────────────────────────────────────────────────────────
// const font = {
//   family: "'Playfair Display', serif",
//   // scale
//   xs:   "0.75rem",   // 12 px — labels / caps
//   sm:   "0.875rem",  // 14 px — meta / author
//   base: "1rem",      // 16 px — body / excerpt
//   md:   "1.125rem",  // 18 px — card title small
//   lg:   "1.375rem",  // 22 px — card title
//   xl:   "1.75rem",   // 28 px — modal title
//   xxl:  "2.25rem",   // 36 px — hero sub
//   hero: "clamp(2rem, 5vw, 3.5rem)", // responsive hero h1
// };

// // ─────────────────────────────────────────────────────────────
// //  Content renderer — supports ##, ###, - lists, **bold**, [img:...], plain paragraphs
// // ─────────────────────────────────────────────────────────────
// function renderInline(text, font) {
//   const parts = text.split(/(\*\*.*?\*\*)/g);
//   return parts.map((part, i) =>
//     part.startsWith("**") && part.endsWith("**")
//       ? <strong key={i} style={{ fontWeight: 700, fontFamily: font.family }}>{part.replace(/\*\*/g, "")}</strong>
//       : part
//   );
// }

// function renderContent(content, accentColor, font) {
//   const lines = content.split("\n");
//   const elements = [];
//   let listItems = [];
//   let key = 0;

//   const flushList = () => {
//     if (listItems.length === 0) return;
//     elements.push(
//       <ul key={key++} style={{ paddingLeft: "1.25rem", marginBottom: "1.125rem", listStyle: "none" }}>
//         {listItems.map((item, i) => (
//           <li key={i} style={{ display: "flex", gap: "0.625rem", marginBottom: "0.5rem", color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.7 }}>
//             <span style={{ color: accentColor, marginTop: "0.3rem", flexShrink: 0 }}>▸</span>
//             <span>{renderInline(item, font)}</span>
//           </li>
//         ))}
//       </ul>
//     );
//     listItems = [];
//   };

//   for (let i = 0; i < lines.length; i++) {
//     const line = lines[i];

//     // ## Section heading
//     if (line.startsWith("## ")) {
//       flushList();
//       const text = line.replace(/^## /, "");
//       elements.push(
//         <div key={key++} style={{ marginTop: "2rem", marginBottom: "0.75rem" }}>
//           <h2 style={{ fontFamily: font.family, fontSize: font.lg, color: "#f5f0e8", fontWeight: 900, marginBottom: "0.375rem", lineHeight: 1.2 }}>{text}</h2>
//           <div style={{ width: "2.5rem", height: "2px", background: accentColor, borderRadius: "2px" }} />
//         </div>
//       );
//       continue;
//     }

//     // ### Sub-heading
//     if (line.startsWith("### ")) {
//       flushList();
//       const text = line.replace(/^### /, "");
//       elements.push(
//         <h3 key={key++} style={{ fontFamily: font.family, fontSize: font.md, color: accentColor, fontWeight: 700, marginTop: "1.25rem", marginBottom: "0.375rem", lineHeight: 1.3 }}>
//           {text}
//         </h3>
//       );
//       continue;
//     }

//     // - list item
//     if (line.startsWith("- ")) {
//       listItems.push(line.replace(/^- /, ""));
//       continue;
//     }

//     // Numbered list  "1. " "2. " etc
//     if (/^\d+\.\s/.test(line)) {
//       listItems.push(line.replace(/^\d+\.\s/, ""));
//       continue;
//     }

//     // Blank line — flush list, skip
//     if (line.trim() === "") {
//       flushList();
//       continue;
//     }

//     // [img:...] inline image
//     if (line.startsWith("[img:") && line.endsWith("]")) {
//       flushList();
//       const src = line.slice(5, -1);
//       elements.push(
//         <img
//           key={key++}
//           src={src}
//           alt="Article illustration"
//           style={{
//             width: "100%",
//             borderRadius: "0.75rem",
//             marginBottom: "1.25rem",
//             display: "block",
//           }}
//         />
//       );
//       continue;
//     }

//     // Normal paragraph line
//     flushList();
//     elements.push(
//       <p key={key++} style={{ marginBottom: "0.875rem", color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.8 }}>
//         {renderInline(line, font)}
//       </p>
//     );
//   }

//   flushList();
//   return elements;
// }

// // ─────────────────────────────────────────────────────────────
// //  ArticleModal
// // ─────────────────────────────────────────────────────────────
// function ArticleModal({ article, onClose }) {
//   if (!article) return null;

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(8,40,50,0.82)",
//         backdropFilter: "blur(6px)",
//         zIndex: 1000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "1.5rem",
//         animation: "fadeIn 0.2s ease",
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "linear-gradient(145deg, #164e5e 0%, #123d4d 100%)",
//           border: "1.5px solid rgba(210,185,145,0.25)",
//           borderRadius: "1.25rem",
//           maxWidth: "680px",
//           width: "100%",
//           maxHeight: "85vh",
//           overflowY: "auto",
//           boxShadow: "0 2rem 5rem rgba(0,0,0,0.5), 0 0 0 1px rgba(210,185,145,0.1)",
//           padding: "2.25rem",
//           animation: "slideUp 0.25s ease",
//         }}
//       >
//         {/* Top row */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1.25rem" }}>
//           <span style={{
//             background: "rgba(210,185,145,0.12)",
//             color: "#d2b991",
//             border: "1px solid rgba(210,185,145,0.3)",
//             borderRadius: "1.25rem",
//             padding: "0.25rem 0.875rem",
//             fontSize: font.xs,
//             fontFamily: font.family,
//             letterSpacing: "0.06em",
//             textTransform: "uppercase",
//             fontWeight: 700,
//           }}>{article.category}</span>

//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.07)",
//               border: "1px solid rgba(255,255,255,0.12)",
//               borderRadius: "50%",
//               color: "#d6cfc2",
//               cursor: "pointer",
//               width: "2.125rem",
//               height: "2.125rem",
//               fontSize: "1.125rem",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontFamily: font.family,
//               transition: "background 0.2s",
//             }}
//             onMouseEnter={(e) => (e.target.style.background = "rgba(255,255,255,0.14)")}
//             onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.07)")}
//           >×</button>
//         </div>

//         <h2 style={{ fontFamily: font.family, fontSize: font.xl, color: "#f5f0e8", marginBottom: "0.375rem", lineHeight: 1.25, fontWeight: 700 }}>
//           {article.title}
//         </h2>
//         <p style={{ color: "#c8e6e0", fontFamily: font.family, fontSize: font.sm, marginBottom: "1.125rem" }}>
//           {article.subtitle}
//         </p>

//         <div style={{ display: "flex", gap: "1.125rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
//           {[`✍ ${article.author}`, `⏱ ${article.readTime}`].map((item, i) => (
//             <span key={i} style={{ color: "#ede8dc", fontSize: font.sm, fontFamily: font.family }}>{item}</span>
//           ))}
//         </div>

//         <div style={{ width: "3rem", height: "2px", background: "#c8a96e", marginBottom: "1.5rem", borderRadius: "2px" }} />

//         {/* Modal image */}
//         {article.image && (
//           <img
//             src={article.image}
//             alt={article.title}
//             style={{
//               width: "100%",
//               height: "14rem",
//               objectFit: "cover",
//               borderRadius: "0.75rem",
//               marginBottom: "1.5rem",
//               display: "block",
//             }}
//           />
//         )}

//         {/* Content */}
//         <div style={{ color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.8 }}>
//           {renderContent(article.content, "#c8a96e", font)}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────
// //  Main Component
// // ─────────────────────────────────────────────────────────────
// export default function HealthArticles() {
//   const [selected, setSelected] = useState(null);
//   const [filter, setFilter]     = useState("All");
//   const [hoveredId, setHoveredId] = useState(null);

//   const categories = ["All", ...Array.from(new Set(allArticles.map((a) => a.category)))];
//   const filtered   = filter === "All" ? allArticles : allArticles.filter((a) => a.category === filter);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&display=swap');
//         @keyframes fadeIn  { from { opacity:0 }              to { opacity:1 } }
//         @keyframes slideUp { from { opacity:0; transform:translateY(1.5rem) } to { opacity:1; transform:translateY(0) } }
//         @keyframes cardIn  { from { opacity:0; transform:translateY(1rem)   } to { opacity:1; transform:translateY(0) } }
//         * { margin:0; padding:0; box-sizing:border-box; }
//         ::-webkit-scrollbar       { width: 6px; }
//         ::-webkit-scrollbar-track { background: #123d4d; }
//         ::-webkit-scrollbar-thumb { background: #0d9488; border-radius: 3px; }
//       `}</style>

//       <div style={{
//         minHeight: "100vh",
//         background: "linear-gradient(160deg, #0f4a58 0%, #0d3f4e 40%, #0b3342 100%)",
//         fontFamily: font.family,
//         padding: "0 0 3.75rem",
//       }}>

//         {/* ── Header ── */}
//         <div style={{
//           background: "linear-gradient(180deg, rgba(13,148,136,0.18) 0%, transparent 100%)",
//           borderBottom: "1px solid rgba(13,148,136,0.3)",
//           padding: "3.25rem 2.5rem 2.5rem",
//           textAlign: "center",
//           position: "relative",
//         }}>
//           <div style={{
//             position: "absolute", top: 0, left: 0, right: 0, height: "2px",
//             background: "linear-gradient(90deg, transparent, #0d9488, #0891b2, transparent)",
//           }} />

//           <p style={{ color: "#0d9488", textTransform: "uppercase", letterSpacing: "0.18em", fontSize: font.xs, fontFamily: font.family, fontWeight: 700, marginBottom: "0.875rem" }}>
//             Health &amp; Wellness
//           </p>

//           <h1 style={{ fontFamily: font.family, fontSize: font.hero, color: "#f5f0e8", fontWeight: 900, lineHeight: 1.1, marginBottom: "0.875rem", letterSpacing: "-0.02em" }}>
//             Medical Knowledge<br />
//             <span style={{ color: "#0d9488" }}>Hub</span>
//           </h1>

//           <p style={{ color: "#ede8dc", maxWidth: "30rem", margin: "0 auto", fontSize: font.base, fontFamily: font.family, lineHeight: 1.6 }}>
//             Evidence-based health articles. Stay informed, stay healthy.
//           </p>
//         </div>

//         {/* ── Filter Tabs ── */}
//         <div style={{ display: "flex", gap: "0.625rem", padding: "1.75rem 2.5rem 0", flexWrap: "wrap", justifyContent: "center" }}>
//           {categories.map((cat) => (
//             <button
//               key={cat}
//               onClick={() => setFilter(cat)}
//               style={{
//                 background: filter === cat ? "linear-gradient(135deg, #0d9488, #0891b2)" : "rgba(255,255,255,0.08)",
//                 border: filter === cat ? "none" : "1px solid rgba(255,255,255,0.2)",
//                 borderRadius: "3.125rem",
//                 padding: "0.5rem 1.25rem",
//                 color: filter === cat ? "#fff" : "#d4f0ec",
//                 cursor: "pointer",
//                 fontSize: font.sm,
//                 fontFamily: font.family,
//                 fontWeight: filter === cat ? 700 : 400,
//                 transition: "all 0.2s",
//                 letterSpacing: "0.03em",
//               }}
//               onMouseEnter={(e) => { if (filter !== cat) e.target.style.borderColor = "#0d9488"; }}
//               onMouseLeave={(e) => { if (filter !== cat) e.target.style.borderColor = "rgba(255,255,255,0.2)"; }}
//             >
//               {cat}
//             </button>
//           ))}
//         </div>

//         {/* ── Count ── */}
//         <p style={{ textAlign: "center", color: "#d6cfc2", fontSize: font.sm, fontFamily: font.family, padding: "1rem 2.5rem 0" }}>
//           {filtered.length} article{filtered.length !== 1 ? "s" : ""}
//         </p>

//         {/* ── Grid ── */}
//         <div style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill, minmax(20rem, 1fr))",
//           gap: "1.5rem",
//           padding: "1.5rem 2.5rem 0",
//           maxWidth: "80rem",
//           margin: "0 auto",
//         }}>
//           {filtered.map((article, index) => (
//             <div
//               key={article.id}
//               onClick={() => setSelected(article)}
//               onMouseEnter={() => setHoveredId(article.id)}
//               onMouseLeave={() => setHoveredId(null)}
//               style={{
//                 background: hoveredId === article.id
//                   ? "linear-gradient(145deg, #1d647a 0%, #195568 100%)"
//                   : "linear-gradient(145deg, #164e5e 0%, #123d4d 100%)",
//                 border: `1.5px solid ${hoveredId === article.id ? "rgba(210,185,145,0.55)" : "rgba(210,185,145,0.18)"}`,
//                 borderRadius: "1.125rem",
//                 padding: "1.75rem",
//                 cursor: "pointer",
//                 transition: "all 0.28s ease",
//                 transform: hoveredId === article.id ? "translateY(-0.3125rem)" : "translateY(0)",
//                 boxShadow: hoveredId === article.id
//                   ? "0 1.25rem 3rem rgba(0,0,0,0.35), 0 0 0 1px rgba(210,185,145,0.12)"
//                   : "0 0.25rem 1rem rgba(0,0,0,0.2)",
//                 animation: `cardIn 0.4s ease ${index * 0.06}s both`,
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               {/* Card image */}
//               {article.image && (
//                 <img
//                   src={article.image}
//                   alt={article.title}
//                   style={{
//                     width: "100%",
//                     height: "10rem",
//                     objectFit: "cover",
//                     borderRadius: "0.75rem",
//                     marginBottom: "1.125rem",
//                     display: "block",
//                   }}
//                 />
//               )}

//               {/* Top row */}
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.125rem" }}>
//                 <span style={{
//                   background: "rgba(210,185,145,0.12)",
//                   color: "#d2b991",
//                   border: "1px solid rgba(210,185,145,0.3)",
//                   borderRadius: "1.25rem",
//                   padding: "0.25rem 0.75rem",
//                   fontSize: font.xs,
//                   fontFamily: font.family,
//                   fontWeight: 700,
//                   letterSpacing: "0.06em",
//                   textTransform: "uppercase",
//                 }}>{article.category}</span>
//                 <span style={{ color: "#d6cfc2", fontSize: font.xs, fontFamily: font.family }}>{article.readTime}</span>
//               </div>

//               {/* Accent line */}
//               <div style={{ width: "2.25rem", height: "3px", background: "#c8a96e", borderRadius: "2px", marginBottom: "0.875rem" }} />

//               <h2 style={{ fontFamily: font.family, fontSize: font.lg, color: "#f5f0e8", marginBottom: "0.375rem", lineHeight: 1.3, fontWeight: 700 }}>
//                 {article.title}
//               </h2>

//               <p style={{ color: "#f0e6c8", fontSize: font.sm, fontFamily: font.family, marginBottom: "0.875rem", fontWeight: 600 }}>
//                 {article.subtitle}
//               </p>

//               <p style={{
//                 color: "#f5f0e8",
//                 fontSize: font.base,
//                 fontFamily: font.family,
//                 lineHeight: 1.65,
//                 flex: 1,
//                 display: "-webkit-box",
//                 WebkitLineClamp: 3,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//               }}>{article.excerpt}</p>

//               <div style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginTop: "1.25rem",
//                 paddingTop: "1rem",
//                 borderTop: `1px solid ${article.color}22`,
//               }}>
//                 <span style={{ color: "#d6cfc2", fontSize: font.xs, fontFamily: font.family }}>✍ {article.author}</span>
//                 <span style={{
//                   color: hoveredId === article.id ? "#1a1a1a" : "#c8a96e",
//                   background: hoveredId === article.id ? "#c8a96e" : "rgba(200,169,110,0.12)",
//                   border: "1px solid rgba(200,169,110,0.35)",
//                   borderRadius: "2rem",
//                   padding: "0.2rem 0.75rem",
//                   fontSize: font.xs,
//                   fontFamily: font.family,
//                   fontWeight: 700,
//                   letterSpacing: "0.04em",
//                   transition: "all 0.25s ease",
//                 }}>
//                   Read more {hoveredId === article.id ? "→" : "›"}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {selected && <ArticleModal article={selected} onClose={() => setSelected(null)} />}
//     </>
//   );
// }
import { useState } from "react";

// ── Article imports ──────────────────────────────────────────
import Article1 from "./Article1";
import Article2 from "./Article2";
import Article3 from "./Article3";
import Article4 from "./Article4";
import Article5 from "./Article5";
import Article6 from "./Article6";
import Article7 from "./Article7";
// import article6 from "./article6";   ← add new articles here

const allArticles = [Article1, Article2, Article3, Article4, Article5,Article6,Article7];

// ─────────────────────────────────────────────────────────────
//  Shared font scale — ALL sizes reduced ~28% from original (15% + another 15%)
// ─────────────────────────────────────────────────────────────
const font = {
  family: "'Playfair Display', serif",
  // scale (original → ~28% smaller)
  xs:   "0.542rem",   // was 0.75rem  (12px → ~8.7px)
  sm:   "0.632rem",   // was 0.875rem (14px → ~10.1px)
  base: "0.723rem",   // was 1rem     (16px → ~11.6px)
  md:   "0.813rem",   // was 1.125rem (18px → ~13px)
  lg:   "0.994rem",   // was 1.375rem (22px → ~15.9px)
  xl:   "1.265rem",   // was 1.75rem  (28px → ~20.2px)
  xxl:  "1.626rem",   // was 2.25rem  (36px → ~26px)
  hero: "clamp(1.445rem, 3.613vw, 2.529rem)", // was clamp(2rem, 5vw, 3.5rem)
};

// ─────────────────────────────────────────────────────────────
//  Content renderer — supports ##, ###, - lists, **bold**, [img:...], plain paragraphs
// ─────────────────────────────────────────────────────────────
function renderInline(text, font) {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={i} style={{ fontWeight: 700, fontFamily: font.family }}>{part.replace(/\*\*/g, "")}</strong>
      : part
  );
}

function renderContent(content, accentColor, font) {
  const lines = content.split("\n");
  const elements = [];
  let listItems = [];
  let key = 0;

  const flushList = () => {
    if (listItems.length === 0) return;
    elements.push(
      <ul key={key++} style={{ paddingLeft: "1.25rem", marginBottom: "1.125rem", listStyle: "none" }}>
        {listItems.map((item, i) => (
          <li key={i} style={{ display: "flex", gap: "0.625rem", marginBottom: "0.5rem", color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.7 }}>
            <span style={{ color: accentColor, marginTop: "0.3rem", flexShrink: 0 }}>▸</span>
            <span>{renderInline(item, font)}</span>
          </li>
        ))}
      </ul>
    );
    listItems = [];
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.startsWith("## ")) {
      flushList();
      const text = line.replace(/^## /, "");
      elements.push(
        <div key={key++} style={{ marginTop: "2rem", marginBottom: "0.75rem" }}>
          <h2 style={{ fontFamily: font.family, fontSize: font.lg, color: "#f5f0e8", fontWeight: 900, marginBottom: "0.375rem", lineHeight: 1.2 }}>{text}</h2>
          <div style={{ width: "2.5rem", height: "2px", background: accentColor, borderRadius: "2px" }} />
        </div>
      );
      continue;
    }

    if (line.startsWith("### ")) {
      flushList();
      const text = line.replace(/^### /, "");
      elements.push(
        <h3 key={key++} style={{ fontFamily: font.family, fontSize: font.md, color: accentColor, fontWeight: 700, marginTop: "1.25rem", marginBottom: "0.375rem", lineHeight: 1.3 }}>
          {text}
        </h3>
      );
      continue;
    }

    if (line.startsWith("- ")) {
      listItems.push(line.replace(/^- /, ""));
      continue;
    }

    if (/^\d+\.\s/.test(line)) {
      listItems.push(line.replace(/^\d+\.\s/, ""));
      continue;
    }

    if (line.trim() === "") {
      flushList();
      continue;
    }

    if (line.startsWith("[img:") && line.endsWith("]")) {
      flushList();
      const src = line.slice(5, -1);
      elements.push(
        <img
          key={key++}
          src={src}
          alt="Article illustration"
          style={{
            width: "100%",
            borderRadius: "0.75rem",
            marginBottom: "1.25rem",
            display: "block",
          }}
        />
      );
      continue;
    }

    flushList();
    elements.push(
      <p key={key++} style={{ marginBottom: "0.875rem", color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.8 }}>
        {renderInline(line, font)}
      </p>
    );
  }

  flushList();
  return elements;
}

// ─────────────────────────────────────────────────────────────
//  ArticleModal
// ─────────────────────────────────────────────────────────────
function ArticleModal({ article, onClose }) {
  if (!article) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(8,40,50,0.82)",
        backdropFilter: "blur(6px)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
        animation: "fadeIn 0.2s ease",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "linear-gradient(145deg, #164e5e 0%, #123d4d 100%)",
          border: "1.5px solid rgba(210,185,145,0.25)",
          borderRadius: "1.25rem",
          maxWidth: "680px",
          width: "100%",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow: "0 2rem 5rem rgba(0,0,0,0.5), 0 0 0 1px rgba(210,185,145,0.1)",
          padding: "2.25rem",
          animation: "slideUp 0.25s ease",
        }}
      >
        {/* Top row */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1.25rem" }}>
          <span style={{
            background: "rgba(210,185,145,0.12)",
            color: "#d2b991",
            border: "1px solid rgba(210,185,145,0.3)",
            borderRadius: "1.25rem",
            padding: "0.25rem 0.875rem",
            fontSize: font.xs,
            fontFamily: font.family,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontWeight: 700,
          }}>{article.category}</span>

          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.07)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: "50%",
              color: "#d6cfc2",
              cursor: "pointer",
              width: "2.125rem",
              height: "2.125rem",
              fontSize: font.md,       // was "1.125rem" → now font.md (~15.3px)
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: font.family,
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.background = "rgba(255,255,255,0.14)")}
            onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.07)")}
          >×</button>
        </div>

        <h2 style={{ fontFamily: font.family, fontSize: font.xl, color: "#f5f0e8", marginBottom: "0.375rem", lineHeight: 1.25, fontWeight: 700 }}>
          {article.title}
        </h2>
        <p style={{ color: "#c8e6e0", fontFamily: font.family, fontSize: font.sm, marginBottom: "1.125rem" }}>
          {article.subtitle}
        </p>

        <div style={{ display: "flex", gap: "1.125rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
          {[`✍ ${article.author}`, `⏱ ${article.readTime}`].map((item, i) => (
            <span key={i} style={{ color: "#ede8dc", fontSize: font.sm, fontFamily: font.family }}>{item}</span>
          ))}
        </div>

        <div style={{ width: "3rem", height: "2px", background: "#c8a96e", marginBottom: "1.5rem", borderRadius: "2px" }} />

        {/* Modal image */}
        {article.image && (
          <img
            src={article.image}
            alt={article.title}
            style={{
              width: "100%",
              height: "14rem",
              objectFit: "cover",
              borderRadius: "0.75rem",
              marginBottom: "1.5rem",
              display: "block",
            }}
          />
        )}

        {/* Content */}
        <div style={{ color: "#f5f0e8", fontFamily: font.family, fontSize: font.base, lineHeight: 1.8 }}>
          {renderContent(article.content, "#c8a96e", font)}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
//  Main Component
// ─────────────────────────────────────────────────────────────
export default function HealthArticles() {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter]     = useState("All");
  const [hoveredId, setHoveredId] = useState(null);

  const categories = ["All", ...Array.from(new Set(allArticles.map((a) => a.category)))];
  const filtered   = filter === "All" ? allArticles : allArticles.filter((a) => a.category === filter);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&display=swap');
        @keyframes fadeIn  { from { opacity:0 }              to { opacity:1 } }
        @keyframes slideUp { from { opacity:0; transform:translateY(1.5rem) } to { opacity:1; transform:translateY(0) } }
        @keyframes cardIn  { from { opacity:0; transform:translateY(1rem)   } to { opacity:1; transform:translateY(0) } }
        * { margin:0; padding:0; box-sizing:border-box; }
        ::-webkit-scrollbar       { width: 6px; }
        ::-webkit-scrollbar-track { background: #123d4d; }
        ::-webkit-scrollbar-thumb { background: #0d9488; border-radius: 3px; }
      `}</style>

      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #0f4a58 0%, #0d3f4e 40%, #0b3342 100%)",
        fontFamily: font.family,
        padding: "0 0 3.75rem",
      }}>

        {/* ── Header ── */}
        <div style={{
          background: "linear-gradient(180deg, rgba(13,148,136,0.18) 0%, transparent 100%)",
          borderBottom: "1px solid rgba(13,148,136,0.3)",
          padding: "3.25rem 2.5rem 2.5rem",
          textAlign: "center",
          position: "relative",
        }}>
          <div style={{
            position: "absolute", top: 0, left: 0, right: 0, height: "2px",
            background: "linear-gradient(90deg, transparent, #0d9488, #0891b2, transparent)",
          }} />

          <p style={{
            color: "#0d9488",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            fontSize: font.xs,          // was "0.75rem"
            fontFamily: font.family,
            fontWeight: 700,
            marginBottom: "0.875rem",
          }}>
            Health &amp; Wellness
          </p>

          <h1 style={{
            fontFamily: font.family,
            fontSize: font.hero,        // was "clamp(2rem, 5vw, 3.5rem)"
            color: "#f5f0e8",
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: "0.875rem",
            letterSpacing: "-0.02em",
          }}>
            Medical Knowledge<br />
            <span style={{ color: "#0d9488" }}>Hub</span>
          </h1>

          <p style={{
            color: "#ede8dc",
            maxWidth: "30rem",
            margin: "0 auto",
            fontSize: font.base,        // was "1rem"
            fontFamily: font.family,
            lineHeight: 1.6,
          }}>
            Evidence-based health articles. Stay informed, stay healthy.
          </p>
        </div>

        {/* ── Filter Tabs ── */}
        <div style={{ display: "flex", gap: "0.625rem", padding: "1.75rem 2.5rem 0", flexWrap: "wrap", justifyContent: "center" }}>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              style={{
                background: filter === cat ? "linear-gradient(135deg, #0d9488, #0891b2)" : "rgba(255,255,255,0.08)",
                border: filter === cat ? "none" : "1px solid rgba(255,255,255,0.2)",
                borderRadius: "3.125rem",
                padding: "0.5rem 1.25rem",
                color: filter === cat ? "#fff" : "#d4f0ec",
                cursor: "pointer",
                fontSize: font.sm,      // was "0.875rem"
                fontFamily: font.family,
                fontWeight: filter === cat ? 700 : 400,
                transition: "all 0.2s",
                letterSpacing: "0.03em",
              }}
              onMouseEnter={(e) => { if (filter !== cat) e.target.style.borderColor = "#0d9488"; }}
              onMouseLeave={(e) => { if (filter !== cat) e.target.style.borderColor = "rgba(255,255,255,0.2)"; }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* ── Count ── */}
        <p style={{
          textAlign: "center",
          color: "#d6cfc2",
          fontSize: font.sm,            // was "0.875rem"
          fontFamily: font.family,
          padding: "1rem 2.5rem 0",
        }}>
          {filtered.length} article{filtered.length !== 1 ? "s" : ""}
        </p>

        {/* ── Grid ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(20rem, 1fr))",
          gap: "1.5rem",
          padding: "1.5rem 2.5rem 0",
          maxWidth: "80rem",
          margin: "0 auto",
        }}>
          {filtered.map((article, index) => (
            <div
              key={article.id}
              onClick={() => setSelected(article)}
              onMouseEnter={() => setHoveredId(article.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{
                background: hoveredId === article.id
                  ? "linear-gradient(145deg, #1d647a 0%, #195568 100%)"
                  : "linear-gradient(145deg, #164e5e 0%, #123d4d 100%)",
                border: `1.5px solid ${hoveredId === article.id ? "rgba(210,185,145,0.55)" : "rgba(210,185,145,0.18)"}`,
                borderRadius: "1.125rem",
                padding: "1.75rem",
                cursor: "pointer",
                transition: "all 0.28s ease",
                transform: hoveredId === article.id ? "translateY(-0.3125rem)" : "translateY(0)",
                boxShadow: hoveredId === article.id
                  ? "0 1.25rem 3rem rgba(0,0,0,0.35), 0 0 0 1px rgba(210,185,145,0.12)"
                  : "0 0.25rem 1rem rgba(0,0,0,0.2)",
                animation: `cardIn 0.4s ease ${index * 0.06}s both`,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Card image */}
              {article.image && (
                <img
                  src={article.image}
                  alt={article.title}
                  style={{
                    width: "100%",
                    height: "10rem",
                    objectFit: "cover",
                    borderRadius: "0.75rem",
                    marginBottom: "1.125rem",
                    display: "block",
                  }}
                />
              )}

              {/* Top row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.125rem" }}>
                <span style={{
                  background: "rgba(210,185,145,0.12)",
                  color: "#d2b991",
                  border: "1px solid rgba(210,185,145,0.3)",
                  borderRadius: "1.25rem",
                  padding: "0.25rem 0.75rem",
                  fontSize: font.xs,    // was "0.75rem"
                  fontFamily: font.family,
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}>{article.category}</span>
                <span style={{ color: "#d6cfc2", fontSize: font.xs, fontFamily: font.family }}>{article.readTime}</span>
              </div>

              {/* Accent line */}
              <div style={{ width: "2.25rem", height: "3px", background: "#c8a96e", borderRadius: "2px", marginBottom: "0.875rem" }} />

              <h2 style={{
                fontFamily: font.family,
                fontSize: font.lg,      // was "1.375rem"
                color: "#f5f0e8",
                marginBottom: "0.375rem",
                lineHeight: 1.3,
                fontWeight: 700,
              }}>
                {article.title}
              </h2>

              <p style={{
                color: "#f0e6c8",
                fontSize: font.sm,      // was "0.875rem"
                fontFamily: font.family,
                marginBottom: "0.875rem",
                fontWeight: 600,
              }}>
                {article.subtitle}
              </p>

              <p style={{
                color: "#f5f0e8",
                fontSize: font.base,    // was "1rem"
                fontFamily: font.family,
                lineHeight: 1.65,
                flex: 1,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}>{article.excerpt}</p>

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "1.25rem",
                paddingTop: "1rem",
                borderTop: `1px solid ${article.color}22`,
              }}>
                <span style={{ color: "#d6cfc2", fontSize: font.xs, fontFamily: font.family }}>✍ {article.author}</span>
                <span style={{
                  color: hoveredId === article.id ? "#1a1a1a" : "#c8a96e",
                  background: hoveredId === article.id ? "#c8a96e" : "rgba(200,169,110,0.12)",
                  border: "1px solid rgba(200,169,110,0.35)",
                  borderRadius: "2rem",
                  padding: "0.2rem 0.75rem",
                  fontSize: font.xs,    // was "0.75rem"
                  fontFamily: font.family,
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  transition: "all 0.25s ease",
                }}>
                  Read more {hoveredId === article.id ? "→" : "›"}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selected && <ArticleModal article={selected} onClose={() => setSelected(null)} />}
    </>
  );
}